<script>
    import {createEventDispatcher} from "svelte";
    import {I_DEAL, I_PROMOTION} from "../../../../../lib/datatypes";
    import {now, toDate, getTimeDiffAsShortText} from "../../../../../lib/dates_times";
    import {promotions} from "../stores/promotions";
    import {deals} from "../stores/deals";
    import Label from "./Label.svelte";
    import SmallNextAction from "./SmallNextAction.svelte";

    const dispatch = createEventDispatcher();
    export let promotions_arr_list;

    const onItemClicked = id => {
        dispatch('promotionClicked', {id:id});
    }
</script>


<table class="min-w-full divide-y divide-gray-300">
<!--    <thead>-->
<!--    <tr>-->
<!--        <th scope="col" class="py-3.5 pl-0 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">Name</th>-->
<!--        <th scope="col" class="hidden px-3 py-3.5 text-left text-sm font-semibold text-gray-900 lg:table-cell">Last Name</th>-->
<!--        <th scope="col" class="hidden px-3 py-3.5 text-left text-sm font-semibold text-gray-900 sm:table-cell">Position</th>-->
<!--        <th scope="col" class="relative py-3.5 pl-3 pr-0 text-left text-sm font-semibold text-gray-900 sm:pr-6">Company</th>-->
<!--    </tr>-->
<!--    </thead>-->
    <tbody class="divide-y divide-gray-200 bg-white">
    {#each promotions_arr_list as promotion_arr (promotion_arr[I_PROMOTION.ID])}
        <tr data-id="{promotion_arr[I_PROMOTION.ID]}" on:click={() => onItemClicked(promotion_arr[I_PROMOTION.ID])}
            class="cursor-pointer">
            <td class="w-1/3 max-w-0 py-4 pl-0 pr-3 text-sm text-gray-700 align-top sm:w-auto sm:max-w-none sm:pl-6">
                <span class="inline-flex align-text-bottom"><Label type={'deal'}></Label></span>
                {$deals.lookup[promotion_arr[I_PROMOTION.ID_DEAL]][I_DEAL.TITLE]}
                <dl class="font-normal lg:hidden">
                    <dt class="sr-only">Updated</dt>
                    <dd class="mt-1 text-gray-400">
                        <time datetime="{promotion_arr[I_PROMOTION.UPDATED]}" title="{promotion_arr[I_PROMOTION.UPDATED]}">{getTimeDiffAsShortText(now().valueOf() - toDate(promotion_arr[I_PROMOTION.UPDATED]))}</time>
                    </dd>
                </dl>
            </td>
            <td class="hidden px-3 py-4 text-sm text-gray-500 align-top lg:table-cell">
                <time datetime="{promotion_arr[I_PROMOTION.UPDATED]}" title="{promotion_arr[I_PROMOTION.UPDATED]}">{getTimeDiffAsShortText(now().valueOf() - toDate(promotion_arr[I_PROMOTION.UPDATED]))}</time>
            </td>
<!--            <td class="hidden px-3 py-4 text-sm text-gray-500 align-top sm:table-cell">{$additional_companies_info[promotion_arr[I_PROMOTION.ID]][0].position}</td>-->
            <td class="w-2/3 sm:w-auto py-4 pl-3 pr-6 align-top sm:pr-0">
                <p class="text font-medium text-gray-800 mb-2">{@html promotion_arr[I_PROMOTION.TITLE]}</p>
                <SmallNextAction next_action={promotion_arr[I_PROMOTION.NEXT_ACTION]}></SmallNextAction>
            </td>
        </tr>
    {:else}
        <tr><td class="text font-medium italic text-gray-400 py-4">No Promotions</td></tr>
    {/each}
    </tbody>
</table>


<style></style>